import { useEffect, useRef, useState } from "react";
import { t } from "i18next";
import Layout from "./Layout";
import {
  CasinoPlatform,
  CrashPlatform,
  CricketPlatform,
  FishingPlatform,
  HomeJackpot,
  HotGames,
  SlotPatform,
  TablePlatform,
} from "./CasinoList";
import { useNavigate } from "react-router-dom";
import { isEmpty, lowerCase } from "lodash";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { isMobile } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { toast } from "react-toastify";
import HomeAfterlogin from "../component/HomeAfterlogin";
import HomeWeb from "./HomeWeb";
import HomeMatchList from "./HomeMatchList";
import HomeCounter from "../component/HomeCoutner";
const Home = () => {
  const [tab, setTab] = useState("hot");
  const navigate = useNavigate();
  const object = {
    jackpot: HomeJackpot,
    hot: HotGames,
    slot: SlotPatform,
    casino: CasinoPlatform,
    crash: CrashPlatform,
    table: TablePlatform,
    fishing: FishingPlatform,
    cricket: CricketPlatform,
  };
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });

  const mapKeys = (slots, casinoList) => {
    return slots.map((slot) => {
      const match = casinoList.find(
        (c) =>
          c.Name.toLowerCase().replace(/[^a-z0-9]/g, "") ===
          slot.name.toLowerCase().replace(/[^a-z0-9]/g, ""),
      );

      return {
        ...slot,
        platFormCode: match?.platFormCode || "NLC",
        gameType: match?.gameType || "SLOT",
        casinoType: match?.casinoType || null,
      };
    });
  };

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const launchCasino = useContextSelector(AuthContext, (ctx) => {
    return ctx.launchCasino;
  });
  const [banner, setBanner] = useState([]);
  const [messagelist, setMessageList] = useState([]);

  let getBannerData = async () => {
    const data = await apiPost(apiPath.getBanner, {
      type: "home_top",
      userId: !isEmpty(user) ? user?.user?._id : "",
    });
    if (data?.status == 200) {
      if (data?.data?.success) {
        setBanner(data?.data?.results?.banners);
      }
    }
  };
  const getMessage = async () => {
    const { status, data: response_users } = await apiGet(apiPath.messageList);
    if (status === 200) {
      if (response_users.success) {
        setMessageList(response_users.results);
      }
    }
  };

  useEffect(() => {
    getBannerData();
    getMessage();
  }, []);
  let condition = ["casino", "crash", "table", "crash", "fishing", "cricket"];

  const handel = (res) => {
    if (!isEmpty(user)) {
      if (isEmpty(res?.platFormCode)) {
        toast.error("Comming Soon");
      } else {
        if (!isEmpty(res?.gameid)) {
        } else {
          launchCasino({
            platForm: res?.platFormCode,
            gameType: res?.gameType,
            casinoType: res?.casinoType,
            isLobbyTrue: res?.isLobbyTrue,
          });
        }
      }
    } else {
      navigate("/login");
    }
  };

  return (
    <Layout>
      {isMobile ? (
        <div className="bg_home">
          <div className="home-banner-box banner-content">
            <div
              className="row hidden-md-and-up no-gutters"
              style={{ marginTop: "10px" }}
            >
              {banner?.length > 0 && (
                <Swiper
                  style={{ width: isMobile ? "92%" : "50%" }}
                  modules={[Autoplay, Navigation]}
                  spaceBetween={30}
                  autoplay={{ delay: 3000 }}
                  loop
                  navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                  }}
                >
                  {banner?.map((res) => {
                    return (
                      <SwiperSlide>
                        <img
                          src={`${process.env.REACT_APP_API_BASE_URL}${res?.banner_path}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "15px",
                          }}
                        />
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              )}{" "}
              {banner?.length > 0 && (
                <>
                  <div
                    ref={prevRef}
                    className="v-window__prev"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "10px",
                      zIndex: 5,
                    }}
                  >
                    <button
                      type="button"
                      className="v-btn v-btn--icon v-btn--round theme--dark v-size--default"
                      aria-label="Previous visual"
                    >
                      <span className="v-btn__content">
                        <i
                          aria-hidden="true"
                          className="v-icon notranslate mdi mdi-chevron-left theme--dark"
                          style={{ fontSize: "36px" }}
                        />
                      </span>
                    </button>
                  </div>
                  {/* Custom Next Button */}
                  <div
                    ref={nextRef}
                    className="v-window__next"
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "10px",
                      zIndex: 5,
                    }}
                  >
                    <button
                      type="button"
                      className="v-btn v-btn--icon v-btn--round theme--dark v-size--default"
                      aria-label="Next visual"
                    >
                      <span className="v-btn__content">
                        <i
                          aria-hidden="true"
                          className="v-icon notranslate mdi mdi-chevron-right theme--dark"
                          style={{ fontSize: "36px" }}
                        />
                      </span>
                    </button>
                  </div>{" "}
                </>
              )}
            </div>
            {messagelist?.length > 0 && (
              <div
                className="row marquee-row no-gutters"
                style={{
                  padding: "1% 12%",
                  "background-color": "rgb(21, 9, 46)",
                }}
              >
                <div className="marquee-wrapper">
                  <div className="marquee-content">
                    {messagelist?.length > 0 &&
                      messagelist?.map((res) => {
                        return (
                          <span className="pr-6 mr-6">
                            {/* <label
                            className="d-inline-block home-announcment-content"
                            style={{ color: "rgb(198, 255, 0)" }}
                          >
                            Scam Alert
                          </label>
                          <label
                            className="d-inline-block home-announcment-content mr-1"
                            style={{ color: "rgb(198, 255, 0)" }}
                          >
                            :
                          </label> */}
                            <label className="d-inline-block home-announcment-content white--text">
                              {res?.message}
                            </label>
                          </span>
                        );
                      })}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="bg_filter">
            {!isEmpty(user) && <HomeAfterlogin />}
            <div className="game-menu pt-0 pb-4">
              <div>
                <div
                  id="game-menu-full"
                  className="row game-menu-wrapper pb-2 hidden-md-and-up no-gutters"
                >
                  <div className="d-flex col col-12">
                    {gameMenuList.map((item) => (
                      <div
                        className="mx-auto"
                        key={item.id}
                        onClick={() => setTab(item?.id)}
                      >
                        {/* <div
                          tabIndex={0}
                          className={`v-card v-card--link v-sheet theme--light game-menu-content font-weight-bold caption ${
                            tab == item?.id ? "selected" : ""
                          }`}
                        >
                          <img src={item.icon} className="side-menu-icon" />
                          <div className="game-menu-title">{t(item.title)}</div>
                        </div> */}

                        <div
                          tabIndex={0}
                          className={`v-card v-card--link v-sheet theme--light game-menu-button font-weight-bold caption ${
                            tab == item?.id ? "selected" : ""
                          }`}
                        >
                          <div
                            className="game-menu-image"
                            style={{ "--src": `url('${item.icon}')` }}
                          >
                            <img
                              url="/static/svg/mobileMenu/homepageHot.png"
                              className="side-menu-icon"
                            />
                          </div>
                          <div className="game-menu-title">{t(item.title)}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <hr
                  role="separator"
                  aria-orientation="horizontal"
                  className="v-divider theme--light"
                />
                <div className="row mt-0 hidden-md-and-up mobile-provider-card-row left-right-gap">
                  <HomeCounter />
                  {object[tab]?.map((res) => {
                    return (
                      <div
                        onClick={() => {
                          if (!["jackpot", "hot", "cricket"].includes(tab)) {
                            navigate(`/casino/${tab}/${lowerCase(res?.key)}`);
                          } else {
                            if (isEmpty(user)) {
                              navigate("/login");
                            } else {
                              if (tab == "cricket") {
                                if (res?.key == "9 Wickets") {
                                  if (isMobile) {
                                    navigate("/inplay-sky");
                                  } else {
                                    navigate("/sports-sky");
                                  }
                                } else if (res?.key == "Velkie") {
                                  navigate("/sports-velki");
                                }
                              } else {
                                handel(res);
                              }
                            }
                          }
                        }}
                        className={`mobile-provider-card-item col ${
                          !condition.includes(tab)
                            ? "gT_homepageHot"
                            : `gT_${tab == "casino" ? "ld" : tab}`
                        } `}
                      >
                        <div
                          className={`v-image v-responsive banner-img theme--light ${
                            condition.includes(tab)
                              ? tab == "crash"
                                ? "sqrBox_img"
                                : ""
                              : "homepageHot_img"
                          }`}
                          cover
                        >
                          <div
                            className="v-responsive__sizer"
                            style={{
                              paddingBottom: condition.includes(tab)
                                ? ["cricket", "fishing"].includes(tab)
                                  ? "33.3333%"
                                  : tab == "crash"
                                    ? "100%"
                                    : "50%"
                                : "100%",
                            }}
                          />
                          <div
                            className={`v-image__image v-image__image--${
                              condition.includes(tab) ? "cover" : "contain"
                            }`}
                            style={{
                              "background-image": `url(${res?.img})`,
                              "background-position": "center center",
                            }}
                          />
                          <div className="v-responsive__content">
                            <img
                              src="/assets/images/hot-icon.png"
                              className="img-hot-home pos_right_top"
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="pt-0">
              <div className="row mx-0 no-gutters justify-center">
                <div className="highlights-container col col-12 pt-2 pb-1">
                  <HomeMatchList />
                </div>
              </div>
            </div>
            <div>
              {/* <div
                onClick={() => navigate("/luckywheel")}
                className="v-image v-responsive wofClass theme--light"
                style={{ height: "70px", width: "72px" }}
              >
                <div
                  className="v-responsive__sizer"
                  style={{ "padding-bottom": "105.521%" }}
                />
                <div
                  className="v-image__image v-image__image--cover"
                  style={{
                    "background-image": 'url("/assets/new/668eb0899634c.gif")',
                    "background-position": "center center",
                  }}
                />
                <div className="v-responsive__content" />
              </div> */}
            </div>
          </div>
        </div>
      ) : (
        <HomeWeb />
      )}
    </Layout>
  );
};
const gameMenuList = [
  {
    id: "jackpot",
    title: "Jackpot",
    icon: "/assets/new/jackpot.svg",
    selected: true,
  },
  {
    id: "hot",
    title: "Hot",
    icon: "/assets/new/homepageHot.svg",
    selected: false,
  },
  {
    id: "slot",
    title: "Slot",
    icon: "/assets/new/rng.svg",
    selected: false,
  },
  {
    id: "casino",
    title: "Casino",
    icon: "/assets/new/ld.svg",
    selected: false,
  },
  {
    id: "crash",
    title: "Crash",
    icon: "/assets/new/crash.svg",
    selected: false,
  },
  {
    id: "cricket",
    title: "Cricket",
    icon: "/assets/new/cricket.svg",
    selected: false,
  },
  {
    id: "table",
    title: "Table",
    icon: "/assets/new/table.svg",
    selected: false,
  },
  {
    id: "fishing",
    title: "Fishing",
    icon: "/assets/new/fishing.svg",
    selected: false,
  },
  // {
  //   id: "sports",
  //   title: "Sports",
  //   icon: "/assets/casinoHome/sb.png",
  //   selected: false,
  // },
];
export default Home;
